import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { ContactActionTypes, ContactData } from './types'
import { fetchError, fetchSuccess } from './actions'
import { db } from '../../components/firebase'
import StringHelper from '../../utils/StringHelper'
import { waitPromise } from '../utils/PromiseUtils'


import { ConvertBodyToPage, UpdateImages, Upload } from './saga-util-update'

// import companies from '../../data/company.json'
// import companiesType from '../../data/companyType.json'

// import images from '../../data/images.json'

function getContactPromise() {
  let promise = () =>
    db
      .onceGetFirestoreCompany()
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}

function* updateCompany(item: any) {
  // console.log("updating resource ", resource.name);
  if (item.name != null) {
    item.url_name = StringHelper(item.name)

    return db
      .FindCompany(item.id)
      .get()
      .then(data => {
        let doc = data.docs[0]
        // console.log("doc",doc)
        if (doc != undefined) {
          // console.log("Document data:", doc.id);
          db.GetCompany()
            .doc(doc.id)
            .set(item)
            .then(function () {
              console.log('Document ' + item.name + ' successfully updated!')
            })
        } else {
          // doc.data() will be undefined in this case
          console.log('No such document!', item.name)
          db.GetCompany()
            .add(item)
            .then(() => {
              console.log('Document ' + item.name + ' successfully updated!')
            })
        }
      })
      .catch(function (error) {
        console.log('Error getting document:', error)
      })
      .catch(err => {
        console.log('updating resource ', item.name, error)
      })
  }
}

function* uploadCompanies(index: number = 0, arr: array = []) {
  // console.log(index)

  // Start by adding all then just update
  let selectedContacts = companies.filter(company => company.name != null)
  let item = selectedContacts[index]

  let res = yield call(updateCompany, item)
  let resolved = { done: false }
  res
    .then(r => {
      resolved.done = true
    })
    .catch(err => console.log('error', err))

  const p = yield call(waitPromise, resolved, ['done'])
  p.then(() => {
    if (index < selectedContacts.length) {
      arr.push(res)
      // const result =  yield* updateCompany(index+1, arr);
    }
  })
  if (index < selectedContacts.length) {
    const result = yield* updateCompany(index + 1, arr)
  }

  // const resourcesRes = yield selectedContacts.map(item => call(updateContact, item))
  return arr
}
function* handleFetch(data: any) {
  console.log('lets upload first')
  // const uploadResult = yield uploadCompanies(0, [])

  console.log('handle project', data)
  try {
    const res = yield getContactPromise()
    yield put(fetchSuccess(res.map(item => item.data())))
  } catch (err) {
    console.log(err)
    if (err instanceof Error) {
      yield put(fetchError(err.stack!))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
}
function* handleEmail(contact: any) {
  try {
    console.log('passing', contact.payload as ContactData)
    const response = yield call(fetch, 'https://europe-west2-c-lab-fe10d.cloudfunctions.net/sendEmail',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(contact.payload as ContactData);
      });
    const data = yield response.json();
    if (data.message) {
      //const data = yield response.json();
      yield put({ type: ContactActionTypes.SEND_EMAIL_SUCCESS, sent: true });

      //console.log(data); // log success message from server
    } else {
      yield put({ type: ContactActionTypes.SEND_EMAIL_ERROR, error: data.error });

      console.error('Failed to send email');
    }
  } catch (error) {
    yield put({ type: ContactActionTypes.SEND_EMAIL_ERROR, error: error });

    console.error('Failed to send email:', error);
  }
}


// This is our watcher function. We use `take*()` functions to watch Redux for a specific action
// type, and run our saga, for example the `handleFetch()` saga above.
function* watchFetchRequest() {
  console.log('watchFetchRequest', arguments)
  yield takeEvery(ContactActionTypes.FETCH_REQUEST, handleFetch)

}
function* watchEmailRequest() {
  console.log("watchEmailRequest", arguments);
  yield takeEvery(ContactActionTypes.SEND_EMAIL, handleEmail)
}

// We can also use `fork()` here to split our saga into multiple watchers.
function* ContactsSaga() {
  yield all([
    fork(watchFetchRequest),
    fork(watchEmailRequest)
  ]);
}

export default ContactsSaga
